import React from "react";
import useBaggageInfoController from "./useBaggageInfo.controller";
import { UIFlightData } from "@flights/types";
import { Stack } from "@bookingcom/bui-react";
import Frame from "../../../../../Frame";
import BaggagePolicies from "../../../../../BaggagePolicies";
import IncludedBaggageList from "./BaggageInfoList";
import { useTrackRemoveBaggageWeightSizeFd } from "../../../../../../../utils/experiments/funnel/flights_web_remove_baggage_weight_size_fd";

const useBaggageInfo = (flight: UIFlightData) => {
  const { header, subheader, includedProducts, includedProductsCompressed, baggagePolicies } =
    useBaggageInfoController(flight);
  const trackRemoveBaggageWeightSizeFd = useTrackRemoveBaggageWeightSizeFd(
    flight,
    includedProducts,
    includedProductsCompressed
  );

  const baggageData =
    includedProducts && trackRemoveBaggageWeightSizeFd() ? includedProductsCompressed : includedProducts;

  if (baggageData) {
    return {
      header,
      subheader,
      content: (
        <Stack gap={2}>
          {baggageData && (
            <IncludedBaggageList
              flightSegments={flight.segments}
              includedProducts={baggageData}
              showRestrictions={!trackRemoveBaggageWeightSizeFd()}
            />
          )}

          {baggagePolicies && (
            <Frame>
              <BaggagePolicies baggagePolicies={baggagePolicies} />
            </Frame>
          )}
        </Stack>
      )
    };
  }

  if (baggagePolicies) {
    return {
      content: (
        <Frame>
          <BaggagePolicies baggagePolicies={baggagePolicies} />
        </Frame>
      )
    };
  }

  return undefined;
};

export default useBaggageInfo;
